import { Center, Modal, Stack, Title } from '@mantine/core';
import { PortalButton } from 'components/Button/PortalButton';

export interface SimpleErrorModalProps {
  title: string;
  description?: string;
  buttonText: string;
  buttonAction: () => void;
  secondButton?: {
    text: string;
    action: () => void;
  };
}

export const SimpleErrorModal = ({
  title,
  description,
  buttonText,
  buttonAction,
  secondButton,
}: SimpleErrorModalProps) => {
  return (
    <Modal opened={true} centered size={'md'} withCloseButton={false} onClose={() => {}}>
      <Center>
        <Stack>
          <Title order={2}>{title}</Title>
          {description && description}
          <PortalButton onClick={() => buttonAction()} label={buttonText} />
          {secondButton && (
            <PortalButton variant={'outline'} onClick={() => secondButton.action()} label={secondButton.text} />
          )}
        </Stack>
      </Center>
    </Modal>
  );
};
